export const isHTMLInputElement = (
  element: Element | null
): element is HTMLInputElement => {
  // @ts-ignore
  return element !== null && element.required !== undefined;
};

export const isHTMLElement = (element: Node | null): element is HTMLElement => {
  // @ts-ignore
  return element !== null && element.style !== undefined;
};

export const toHTMLElement = (element: Node | null) => {
  if (!isHTMLElement(element)) {
    throw new Error('not an HTMLElement');
  }

  return element;
};

export const first = <T>(
  predicate: (element: T) => boolean,
  elements: T[]
): T | null =>
  elements.reduce(
    (acc, val) => acc || !predicate(val) ? acc : val,
    null
  );

export const nodeListToArray = <T extends Node>(
  nodeList: NodeListOf<T>
): T[] => {
  const toReturn = [];

  /* tslint:disable:prefer-for-of */
  for (let index = 0; index < nodeList.length; index++) {
    /* tslint:enable*/
    const element = nodeList[index];
    toReturn.push(element);
  }

  return toReturn;
};

export const nodeListToElements = (list: NodeListOf<Element>) => {
  const toReturn: Element[] = [];
  /* tslint:disable:prefer-for-of */
  for (let index = 0; index < list.length; index++) {
    /* tslint:enable*/
    const element = list[index];
    toReturn.push(element);
  }

  return toReturn;
};

export const unsafe = <T>(data: T | null) => {
  if (data === null) {
    throw new Error('error, value is null');
  }

  return data;
};

export const generateCaughtError = <T>(message: string, defaultData?: T) => {
  try {
    throw new Error(message);
  } catch (e) {
    /* tslint:disable */
    console.error(`Caught error : ${message}`);
    /* tslint:enable */
    return defaultData;
  }
};



// WEBPACK FOOTER //
// ../work/src/js/ts-utils.ts